// @ts-nocheck
const CONSENT_KEY = 'ac_cookie_consent';

function hasConsent() {
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem(CONSENT_KEY) === 'accepted';
}

function browserFamily(userAgent = '') {
  if (/Edg\//.test(userAgent)) return 'Edge';
  if (/OPR\//.test(userAgent)) return 'Opera';
  if (/Firefox\//.test(userAgent)) return 'Firefox';
  if (/Chrome\//.test(userAgent)) return 'Chrome';
  if (/Safari\//.test(userAgent)) return 'Safari';
  return 'Other';
}

function osFamily(userAgent = '') {
  if (/Windows/.test(userAgent)) return 'Windows';
  if (/Android/.test(userAgent)) return 'Android';
  if (/iPhone|iPad|iPod/.test(userAgent)) return 'iOS';
  if (/Mac OS X/.test(userAgent)) return 'macOS';
  if (/Linux/.test(userAgent)) return 'Linux';
  return 'Other';
}

function deviceClass(userAgent = '') {
  if (/iPad|Tablet/i.test(userAgent)) return 'tablet';
  if (/Mobi|Android|iPhone|iPod/i.test(userAgent)) return 'mobile';
  return 'desktop';
}

function analyticsSessionId() {
  if (!hasConsent()) return '';
  const key = 'ac_analytics_session';
  try {
    const current = window.sessionStorage.getItem(key);
    if (current) return current;
    const value = globalThis.crypto?.randomUUID?.()
      || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 14)}`;
    window.sessionStorage.setItem(key, value);
    return value;
  } catch {
    return '';
  }
}

function referrerHost() {
  try {
    return document.referrer ? new URL(document.referrer).hostname : '';
  } catch {
    return '';
  }
}

function browserMetadata() {
  if (!hasConsent() || typeof navigator === 'undefined') return {};
  const language = String(navigator.language || '').slice(0, 35);
  const localeRegion = language.match(/[-_]([A-Za-z]{2})\b/)?.[1]?.toUpperCase() || '';
  const userAgent = String(navigator.userAgent || '');
  const query = new URLSearchParams(window.location.search);
  let timezone = '';
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch {
    timezone = '';
  }
  return {
    sessionId: analyticsSessionId(),
    browserLanguage: language,
    siteLocale: String(document.documentElement.lang || '').slice(0, 20),
    localeRegion,
    timezone: String(timezone).slice(0, 80),
    device: deviceClass(userAgent),
    browser: browserFamily(userAgent),
    os: osFamily(userAgent),
    screen: `${Number(window.screen?.width || 0)}x${Number(window.screen?.height || 0)}`,
    referrerHost: referrerHost().slice(0, 120),
    utmSource: String(query.get('utm_source') || '').slice(0, 100),
    utmMedium: String(query.get('utm_medium') || '').slice(0, 100),
    utmCampaign: String(query.get('utm_campaign') || '').slice(0, 140),
  };
}

export function initAnalytics() {
  if (typeof window === 'undefined') return false;
  if (!hasConsent()) return false;
  if (typeof window.__configureAnalytics === 'function') {
    window.__configureAnalytics();
  }
  return Boolean(window.__acAnalyticsConfigured);
}

function emit(name, params = {}) {
  if (typeof window === 'undefined') return;
  if (!hasConsent()) return;

  emitProductEvent(name, params);

  initAnalytics();

  if (typeof window.gtag === 'function' && window.__acAnalyticsConfigured) {
    window.gtag('event', name, params);
  }

  if (typeof window.plausible === 'function') {
    window.plausible(name, { props: params });
  }

  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push({ event: name, ...params });
  }
}

export function disableAnalytics() {
  if (typeof window === 'undefined') return;
  window.__acAnalyticsConfigured = false;
  document.querySelectorAll('script[data-ac-analytics="google"]').forEach((script) => script.remove());
  window.dataLayer = [];
  try {
    window.sessionStorage.removeItem('ac_analytics_session');
  } catch {
    // Storage may be unavailable in privacy-restricted browsers.
  }
}

function emitProductEvent(name, params = {}) {
  const payload = {
    eventName: name,
    surface: String(params.page_path || params.source || window.location.pathname || '').slice(0, 120),
    resourceType: params.job_id ? 'job' : params.slug ? 'content' : '',
    resourceId: String(params.job_id || params.slug || '').slice(0, 180),
    outcome: String(params.outcome || '').slice(0, 80),
    metadata: browserMetadata(),
  };
  fetch('/api/product-events', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {});
}

export function trackPageView(path) {
  emit('page_view', {
    page_path: path,
    page_location: typeof window !== 'undefined' ? window.location.href : path,
    page_title: typeof document !== 'undefined' ? document.title : path
  });
}

export function trackSearch(params = {}) {
  emit('search', params);
}

export function trackJobClick(job = {}) {
  emit('job_click', {
    job_id: String(job.id || ''),
    company: job.company || '',
    title: job.title || '',
    source: job.applyUrl ? 'apply_url' : 'detail'
  });
}

export function trackCompanyClick(company = {}) {
  emit('company_click', {
    company: company.name || company.company || '',
    slug: company.slug || company.companySlug || ''
  });
}

export function trackArticleClick(article = {}) {
  emit('article_click', {
    slug: article.slug || '',
    title: article.title || ''
  });
}
